<template>
  <div>
    <v-card :class="!isFlat ? 'card-custom-shadow' : ''" :flat="isFlat">
      <v-card-text class="fs-12" :class="!isFlat ? '' : 'pa-0'">
        <div class="fs-14px black--text mb-2" v-if="!isFlat">Thanh toán:</div>

        <div class="mb-5 d-flex align-center justify-center">
          <v-radio-group
            v-model="order.payment_method"
            hide-details
            class="c-input-small w-100"
            @change="onPaymentMethodChanged"
          >
            <v-row dense>
              <v-col cols="6">
                <v-radio label="Chuyển khoản" :value="1"></v-radio>
              </v-col>
              <v-col cols="6" v-if="isShowCardPayment">
                <v-radio label="Quẹt thẻ" :value="2"></v-radio>
              </v-col>
            </v-row>
          </v-radio-group>
        </div>

        <div class="text-center">
          <div v-if="qrString && order.payment_method == 1" class="qr-block">
            <qrcode-vue
              :value="qrString"
              :size="150"
              level="L"
              id="paymentQrCode"
            ></qrcode-vue>
            <div class="mb-1">
              <span
                class="qr-download-icon cursor-pointer primary--text text-decoration-underline"
                @click="downloadQrPayment"
              >
                QR download
              </span>
            </div>
          </div>
          <div v-else>
            <div class="emove-loader mx-auto my-5"></div>
            <div class="primary--text">Chờ quẹt thẻ</div>
          </div>
          <div class="fs-16px font-weight-medium error--text">
            {{
              isDetail
                ? formatNumber(info.remaining_amount)
                : formatNumber(info.total_amount)
            }}
            VND
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  ORDER_CREATE_DEFAULT_PAYMENT,
  ORDER_CREATE_DEFAULT_PAYMENT_BOOKING,
} from "@/libs/const";
import { httpClient } from "@/libs/http";
import QrcodeVue from "qrcode.vue";

export default {
  name: "Payment",
  components: {
    QrcodeVue,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    isFlat: {
      type: Boolean,
      default: () => false,
    },
    isBranch: {
      type: Boolean,
      default: () => false,
    },
    isDetail: {
      type: Boolean,
      default: () => false,
    },
    isShowCardPayment: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    order: {},
    qrString: null,
  }),
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    if (this.isBranch) {
      this.order = { ...ORDER_CREATE_DEFAULT_PAYMENT };
    } else {
      this.order = { ...ORDER_CREATE_DEFAULT_PAYMENT_BOOKING };
    }
  },
  mounted() {
    this.getQr();
    this.onPaymentMethodChanged();
  },
  methods: {
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_PAYMENT };
    },
    goBack() {
      this.$emit("goBack", true);
    },
    async onPaymentMethodChanged() {
      await httpClient.post("/payment/v1/set-wait-payment-method", {
        id_order: this.info.id,
        id_branch: this.info.id_branch,
        payment_method: this.order.payment_method,
      });
    },
    async getQr() {
      if (!this.info.id) {
        return false;
      }
      const { data } = await httpClient.post("/order/v1/get-payment-qr", {
        id_order: this.info.id,
      });
      this.qrString = data;
    },
  },
};
</script>
